/**
 * 前端监控上报逻辑（临时：仅本地 console.log，后续接入新上报方案）
 */

/**
 * 获取页面类型
 * @param {string} pagePath - 页面路径
 * @returns {string} 页面类型
 */
function getPageType(pagePath) {
  if (!pagePath) {
    return 'unknown';
  }

  if (pagePath.indexOf('/share') !== -1) {
    return 'share';
  }

  if (pagePath.indexOf('/make') !== -1 || pagePath.indexOf('/edit') !== -1 || pagePath.indexOf('/editor') !== -1) {
    return 'editor';
  }

  return pagePath.replace(/\//g, '_');
}

/**
 * 构建监控上下文
 * @returns {object} 监控上下文
 */
function buildFrontendMonitorContext() {
  let pageUrl = '';
  let pagePath = '';

  if (typeof window !== 'undefined' && window.location) {
    pageUrl = window.location.href || '';
    pagePath = window.location.pathname || '';
  }

  return {
    projectType: 'mainloading',
    pageType: getPageType(pagePath),
    pageUrl,
    pagePath,
    mainloadingMode: 'serve',
    userAgent: typeof navigator !== 'undefined' ? navigator.userAgent || '' : '',
    timestamp: Date.now()
  };
}

export function useMonitor() {
  return {
    /**
     * 发送前端监控（临时：仅输出到 console，后续接入新上报方案）
     * @param {object} payload - 监控数据
     */
    sendFrontendMonitor(payload) {
      const logData = Object.assign({}, buildFrontendMonitorContext(), payload || {});
      console.log('[MainloadingServe][monitor] (LOCAL ONLY)', logData);

      // TODO: 后续接入新的上报方案时，在此处替换实现
    }
  };
}
